export const isUnitedStatesOverride = function () {
  const country =
    window.actionkit.form &&
    window.actionkit.form.country &&
    window.actionkit.utils.val(window.actionkit.form.country);

  return country == "United States" || country == "US";
};
